// curl -X GET -H "Content-Type: application/json" -H "Authorization: Bearer 99b53cf088b6cac978ab24901547033c8b9350a5a15d67d0331ca2abc11f7dde" "https://api.digitalocean.com/v2/droplets?page=1&per_page=1"

export const DOToken = "99b53cf088b6cac978ab24901547033c8b9350a5a15d67d0331ca2abc11f7dde";
